import React from "react"
import { useTranslation } from "react-i18next"

import { DataGridToolbar } from "@/nzds/data-grid"
import { useDownloadIntervalRecordsXlsx } from "@/services/interval"

import { MenuItem } from "@mui/material"
import type { GridSlots, PropsFromSlot } from "@mui/x-data-grid-pro"

interface IntervalDataRecordsGridToolbarProps extends PropsFromSlot<
  GridSlots["toolbar"]
> {
  canDownload: boolean
  downloadHref?: string
  excelDownloadHref?: string
  isRecordCountLoading?: boolean
  recordCount?: number
}

const startRecordsExport = (
  exportFile: (href: string) => void,
  href: string | undefined
): void => {
  if (!href) {
    return
  }

  exportFile(href)
}

export const IntervalDataRecordsGridToolbar: React.FC<
  IntervalDataRecordsGridToolbarProps
> = ({
  canDownload,
  downloadHref,
  excelDownloadHref,
  isRecordCountLoading,
  recordCount,
}) => {
  const { t } = useTranslation("sites")
  const { intervalRecordsExportIsPending, intervalRecordsExportMutate } =
    useDownloadIntervalRecordsXlsx()
  const isExportDisabled = !canDownload || intervalRecordsExportIsPending

  return (
    <DataGridToolbar
      isMoreMenuDisabled={!canDownload}
      isMoreMenuLoading={intervalRecordsExportIsPending}
      isRecordCountLoading={isRecordCountLoading}
      moreMenuItems={
        <>
          <MenuItem
            component="button"
            disabled={isExportDisabled}
            onClick={() => {
              startRecordsExport(intervalRecordsExportMutate, downloadHref)
            }}
          >
            {t("menuItem.exportCsv", { ns: "common" })}
          </MenuItem>
          <MenuItem
            component="button"
            disabled={isExportDisabled}
            onClick={() => {
              startRecordsExport(intervalRecordsExportMutate, excelDownloadHref)
            }}
          >
            {t("menuItem.exportExcel", { ns: "common" })}
          </MenuItem>
        </>
      }
      recordCount={recordCount}
    />
  )
}
